import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import styled from "@emotion/styled";

const Container = styled(motion.div)({
  // zIndex: 1002,
});

type Props = {
  isShow: boolean;
  children: React.ReactNode;
  nonAnimation?: boolean;
};

const FadeInContainer = ({ children, isShow, nonAnimation = false }: Props) => {
  if (nonAnimation) {
    return <Container>{children}</Container>;
  }

  return (
    <AnimatePresence>
      {isShow && (
        <Container
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 1, type: "spring" }}>
          {children}
        </Container>
      )}
    </AnimatePresence>
  );
};

export default FadeInContainer;
